import { useEffect } from 'react';
import { useIdentity } from '@/framework';
import { ReferenceLinesStageOperateController } from '../stage-operate-controller';

/** 监听舞台尺寸事件，并将参考线业务作为 StageOperate 的上层扩展挂载。 */
export const useReferenceLinesEvents = () => {
    const identity = useIdentity();

    useEffect(() => {
        const controller = new ReferenceLinesStageOperateController(identity);
        return controller.mount();
    }, [identity]);
};
